// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import PropertySearchField from "../../Home/Search";
import NotFound from "../../Error/NotFound";

interface SubHeaderHomeProps {
  agencyName?: string;
  isSeo: boolean;
  showSearchForm?: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({
  isSeo,
  showSearchForm = true // Default a true se non specificato
}) => {
  const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);
  const { t } = useTranslation();

  if (loading) return <LoadingIndicator />;
  if (error) return <SlowLoadComponent />;

  if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

  return (
    <section
      className="banner bg-holder bg-overlay-black-20"
      style={{ backgroundImage: 'url(/assets/images/bg-homeHero.jpg)' }}
    >
      <div className="container">
        <div className="row">
          <div className="col-12">
            {/* Titolo H1/H2 con nome agenzia */}
            {isSeo ? (
              <h1 className="text-white text-center mb-2">{agency.agencyName}</h1>
            ) : (
              <h2 className="text-white text-center mb-2">{agency.agencyName}</h2>
            )}
            <p className="lead text-center text-white mb-4 font-weight-normal">
              {t('homePage.hero.subTitle')}
            </p>
            {showSearchForm && <PropertySearchField searchData={{}} />}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubHeaderHome;